import {http, HttpResponse} from 'msw';
import {SetupServerApi} from 'msw/node';

import {CorGetBankTransferSettingApiResponse} from '../types';

export const bankTransferSettingEnabledMock: CorGetBankTransferSettingApiResponse = {
  isDefaultBankTransferAllowed: true,
  invoiceMaturity: 30,
  paymentLimit: 10000,
};

export const bankTransferSettingDisabledMock: CorGetBankTransferSettingApiResponse = {
  isDefaultBankTransferAllowed: false,
  invoiceMaturity: 0,
  paymentLimit: 0,
};

export const getBankTransferSettingResponseInterceptor = (
  server: SetupServerApi,
  mockData: CorGetBankTransferSettingApiResponse = bankTransferSettingEnabledMock
) => server.use(http.get('*/core/v1/bank-transfer-setting', () => HttpResponse.json(mockData)));

export const updateBankTransferSettingResponseInterceptor = (
  server: SetupServerApi,
  mockData = {bankTransferSettingId: 'test-setting-id'}
) => server.use(http.put('*/core/v1/bank-transfer-setting', () => HttpResponse.json(mockData)));

export const allowDefaultBankTransferResponseInterceptor = (server: SetupServerApi) =>
  server.use(
    http.post('*/core/v1/bank-transfer-setting/allow-default', () =>
      HttpResponse.json(null, {status: 200})
    )
  );

export const disallowDefaultBankTransferResponseInterceptor = (server: SetupServerApi) =>
  server.use(
    http.post('*/core/v1/bank-transfer-setting/disallow-default', () =>
      HttpResponse.json(null, {status: 200})
    )
  );

export const metadaCheckoutApiMock = {
  bankTransferSettingEnabledMock,
  bankTransferSettingDisabledMock,
  getBankTransferSettingResponseInterceptor,
  updateBankTransferSettingResponseInterceptor,
  allowDefaultBankTransferResponseInterceptor,
  disallowDefaultBankTransferResponseInterceptor,
};
